<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const testimonialSchema = defineSchema({
	title: $.text('Name & Affiliation'),
	description: $.richtext('Quote', { basic: true }),
})
const defaults = {
	title: 'Recognition from Rabbis and Scholars',
	description: 'Educators, clergy, and thought leaders reflect on the impact of our work:',
	under: '',
	testimonials: [
		{
			title: 'Rabbi Dr. David Golinkin, President Emeritus, Schechter Seminary',
			description: 'TheTorah.com provides a valuable service by making critical biblical scholarship accessible to a broad audience while maintaining academic rigor.',
		},
		{
			title: 'Dr. Amy-Jill Levine, Vanderbilt University',
			description: 'This work bridges the gap between scholarly research and public engagement, bringing important insights to diverse communities.',
		},
		{
			title: 'Rabbi Dr. Donniel Hartman, Hartman Institute',
			description: 'An important resource for anyone seeking to understand the Bible in its historical and literary context.',
		},
	],
}
const schema = defineSchema({
	title: $.text('Title'),
	description: $.text('Description'),
	under: $.text('Under Text'),
	testimonials: $.array('Testimonials', testimonialSchema, { collapsible: true }),
})
export const Endorsements = defineBlock({ name: 'Endorsements', label: 'Endorsements', icon: 'star', order: 6, schema, defaults })
</script>
<script setup lang="ts">

import { Card, Icon, Swiper, $ } from '@bagelink/vue'
const myData = defineProps<{
	title?: string
	description?: string
	under?: string
	testimonials?: Array<{
		id?: number
		image_path_key?: string
		title: string
		description: string
		href?: string
	}>
}>()
</script>

<template>
	<div id="recognition" class="grid grid-wrap-3 pt-10 pb-8 m_pb-4 m_pt-5 m_px-1 gap-2 w1050px">
		<div>
			<h3 class="m-0 txt40 regular m_txt30 line-height-13 balance">
				{{ myData.title }}
			</h3>
			<div class="line my-1-5 w160px" />
			<p>
				{{ myData.description }}
			</p>
		</div>

		<div class="grid-span-2 relative">
			<Card class="bg-gray-light px-3 m_p-1">
				<img src="@/assets/quotation-mark.svg" alt="" class="pointer-events-none h30px mb-2">
				<Swiper
					:items="testimonials"
					:slides-per-view="1"
					:autoplay="{ delay: 5000 }"
					loop
					navigation
					class="endorsementsCarousel -mb-4 m_mb-0"
				>
					<template #default="{ item }">
						<div class="flex column flex-stretch pb-1">
							<div class="pb-2" v-html="item.description" />
							<p class="bold border-start mt-auto px-1 py-025 m_mt-1">
								{{ item.title }}
							</p>
						</div>
					</template>
					<template #next-button>
						<div class="bg-gray aspect-ratio-1 h60px flex justify-content-center hover">
							<Icon color="white" size="2" name="arrow_forward" />
						</div>
					</template>
					<template #prev-button>
						<div class="bg-gray aspect-ratio-1 h60px flex justify-content-center hover">
							<Icon color="white" size="2" name="arrow_back" />
						</div>
					</template>
				</Swiper>
			</Card>
		</div>
	</div>
</template>

<style>
.endorsementsCarousel .swi-ctrl {
	justify-content: start !important;
	padding: 0 !important;
	position: relative !important;
	top: auto !important;
	transform: none !important;
	height: auto !important;
	gap: 0.5rem;
}

.endorsementsCarousel .swi-prev,
.endorsementsCarousel .swi-next {
	background: var(--bgl-gray) !important;
	border-radius: 0 !important;
	height: 60px !important;
	width: 60px !important;
}
</style>
